import React, { memo } from 'react';
import { DataListControl } from 'reactApp/ui/DataListControl/DataListControl';
import { Hint } from 'reactApp/ui/Hint/Hint';

import { Restore as RestoreNew } from './Restore/Restore';

const RestoreComponent = memo<{ onClick: () => void }>(({ onClick }) => {
    return (
        <div>
            <Hint text="Восстановить">
                <div>
                    <DataListControl type="restore" onClick={onClick} />
                </div>
            </Hint>
        </div>
    );
});

RestoreComponent.displayName = 'Restore';

export const Restore = Object.assign(RestoreComponent, { New: RestoreNew });
